module.exports = __webpack_public_path__ + "static/media/oberflex-zebranoblancpoudre-2560x1440.5166239e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranoblancpoudre-2560x1440.jpg
// module id = 1077
// module chunks = 37